import AIActionPlanPanel from '../../components/AIActionPlanPanel';

export default function AgencyAIActionPlans() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-[2.25rem] font-semibold tracking-tightest text-glass-text">AI Action Plans</h1>
        <p className="mt-1 text-glass-text-2">Plan, approve, and execute campaign operations with human review.</p>
      </div>
      <AIActionPlanPanel />
    </div>
  );
}
